import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Select, Button, Table, Input, Modal, Tooltip } from 'antd'

import { req_page_ccw_course_students } from '../../api'

import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'
import { usrRole } from '../../utils/dataUtil'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import memoryUtils from '../../utils/memoryUtils'

import StudentWorksListModal from './student-works-list-modal'

class ObjectCourseStudents extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        deviceWidth: 0,
        loading: false,
        userLevel: 'NORMAL',
        items: [],
        item: {},
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: '',

        domnloadFile: '',

        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),

        isShowModal: false,
    }

    UNSAFE_componentWillMount() {
        window.removeEventListener("resize", this.resize.bind(this));

        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        this.api_page_items(1)
    }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }


    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到

        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user
        const { OpenCourseIdKey } = this.props.location.state

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true, items:[] })
        const result = await req_page_ccw_course_students(userCode, userLevel, OpenCourseIdKey, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })


        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })

        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '開課流水號',
                dataIndex: 'OpenCourseIdKey',
                width: 30,
                responsive: ['md'],
            },
            {
                title: '課程名稱',
                dataIndex: 'CourseTwName',
                width: 40,
                responsive: ['md'],
            },
            {
                title: '學號',
                dataIndex: 'StudentId',
                width: 40,
                responsive: ['md'],
            },
            {
                title: '姓名',
                dataIndex: 'TwName',
                width: 40,
            },
            {
                title: '',
                dataIndex: '',
                width: 65,
                responsive: ['md'],
                render: (item) => {
                    const { ObjectTotal } = item
                    return (
                        <>
                            <button type="button" className={ObjectTotal === 0 ? "btn btn-outline-dark btn-sm": "btn btn-outline-success btn-sm"} onClick={() => this.handle_show_ui_modal('view', item)}><i className="fas fa-file-invoice"></i><span> 作品管理</span></button>
                        </>
                    )
                },
            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)

                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)

                });
            }
        } else {
            this.api_page_items(pagination.current)

        }
    }

    handle_data_refresh = () => {
        //console.log(this.current)
        //console.log(this.state.pagination)
        this.api_page_items(this.current)
    }

    handle_pages_back_stautus = () => {
        memoryUtils.pagination.isGoBack = true
        this.props.history.goBack()
    }


    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'view':
                this.setState({ isShowModal: true, item })
                break;
            case 'download':

                break;
            default:
        }
    }
    /////////////////////////////////////////////////////////////     
    render() {
        const { AcademicYear, AcademicSemester, OpenCourseTwName, CourseTeacherName } = this.props.location.state
        const { loading, items, pagination, searchField, searchValue, isShowModal, item } = this.state

        const title = (
            <>
                <Button type='link' style={{ color: 'green', fontSize: 25 }} onClick={() => this.handle_pages_back_stautus()} ><i className="fas fa-angle-double-left"></i></Button>
                <span style={{ color: 'green', fontSize: 18 }}>{AcademicYear + '學年度 / 第' + AcademicSemester + '學期 / ' + OpenCourseTwName + ' / ' + CourseTeacherName}</span><p />
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='NONE'>搜索條件</Select.Option>
                    <Select.Option value='ObjectTotal'>作品數</Select.Option>
                    <Select.Option value='StudentId'>學號</Select.Option>
                    <Select.Option value='TwName'>學生姓名</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 100, backgroundColor: 'LightYellow', margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i><span style={{ marginLeft: '4px' }}> 查詢</span></Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        //onChange: this.handle_table_change,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    visible={isShowModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowModal: false })
                        this.handle_data_refresh()
                    }}
                    onCancel={() => {
                        this.setState({ isShowModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <StudentWorksListModal courseStudent={item} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ObjectCourseStudents)